import { useAppMeta } from "hooks";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import React from 'react'
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useGetCustomerDetailQuery, useUpdateCustomerMutation } from "store/services/customerApi";
import CustomerForm from "./customerComponents/CustomerForm";

const CustomerEditScreen = () => {

  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Customer Profile", path: "/app/crm/customerProfile/list" },
    { title: "Edit Customer Profile" },
  ];

  // RTK Query
  const {
    data: customerProfileDetail,
    isLoading: loadingCustomer,
    error,
  } = useGetCustomerDetailQuery(id);


  const [updateCustomer, { isLoading: updatingCustomer }] = useUpdateCustomerMutation();

  // methods
  const handleUpdateCustomer = async (data) => {
    const _payload = data;

    delete _payload.disclaimers;

    try {
      await updateCustomer(_payload).unwrap();
      toast.success("Customer successfully updated!");
      navigate(`/app/crm/customerProfile/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Customer!"
      );
    }
  };

  useAppMeta("Edit Customer");
  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingCustomer || updatingCustomer}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <CustomerForm
          isBusy={loadingCustomer || updatingCustomer}
          customerProfileDetail={customerProfileDetail}
          onSubmit={handleUpdateCustomer}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  )
}

export default CustomerEditScreen;

